var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_340)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0956 47.6167C31.5257 48.423 31.9565 49.1495 32.3682 49.7933C27.9936 48.8095 24.1976 46.2967 21.5709 42.8457C23.3045 41.8695 25.5249 40.8575 28.1941 40.117C28.9528 43.0925 30.0231 45.6057 31.0956 47.6167ZM34.4045 45.852C33.4728 44.1053 32.539 41.9238 31.8662 39.339C33.3145 39.124 34.8605 39 36.5002 39C38.1397 39 39.6858 39.124 41.1338 39.3387C40.461 41.9238 39.5272 44.1053 38.5955 45.852C37.8485 47.2528 37.1042 48.371 36.5 49.1893C35.8958 48.371 35.1515 47.2528 34.4045 45.852ZM30.875 31.5C30.875 32.9603 30.9732 34.3462 31.1465 35.6547C32.8172 35.3985 34.6035 35.25 36.5002 35.25C38.3967 35.25 40.183 35.3982 41.8535 35.6547C42.0268 34.346 42.125 32.9603 42.125 31.5C42.125 30.0397 42.0268 28.654 41.8535 27.3453C40.183 27.6015 38.3967 27.75 36.5002 27.75C34.6035 27.75 32.8172 27.6015 31.1465 27.3453C30.9732 28.6538 30.875 30.0397 30.875 31.5ZM27.4672 26.572C27.2494 28.1195 27.125 29.7635 27.125 31.5C27.125 33.2365 27.2494 34.8805 27.4672 36.428C24.2835 37.2827 21.647 38.488 19.6081 39.6478C18.4174 37.184 17.75 34.42 17.75 31.5C17.75 28.58 18.4174 25.8161 19.6081 23.3522C21.6468 24.5118 24.2832 25.7171 27.4672 26.572ZM31.8662 23.6611C33.3145 23.8761 34.8605 24 36.5002 24C38.1397 24 39.6858 23.8761 41.1338 23.6612C40.461 21.0764 39.5272 18.8948 38.5955 17.148C37.8485 15.7474 37.1042 14.6289 36.5 13.8108C35.8958 14.6289 35.1515 15.7474 34.4045 17.148C33.4728 18.8948 32.539 21.0763 31.8662 23.6611ZM45.5327 26.5723C45.7505 28.1198 45.875 29.7638 45.875 31.5C45.875 33.2365 45.7505 34.8802 45.5327 36.4277C48.7165 37.2827 51.353 38.488 53.392 39.6478C54.5825 37.1838 55.25 34.4198 55.25 31.5C55.25 28.5802 54.5825 25.8162 53.392 23.3523C51.3532 24.5119 48.7168 25.7173 45.5327 26.5723ZM51.429 20.1545C49.6952 21.1308 47.475 22.1426 44.806 22.8832C44.0473 19.9076 42.977 17.3942 41.9045 15.3833C41.4743 14.5769 41.0435 13.8506 40.6318 13.2068C45.0065 14.1906 48.8025 16.7034 51.429 20.1545ZM28.1941 22.8831C25.525 22.1425 23.3047 21.1307 21.571 20.1543C24.1976 16.7034 27.9936 14.1906 32.368 13.2068C31.9565 13.8506 31.5258 14.5769 31.0956 15.3832C30.0231 17.3942 28.9528 19.9075 28.1941 22.8831ZM44.806 40.1168C44.0473 43.0925 42.977 45.6057 41.9045 47.6167C41.4743 48.423 41.0435 49.1495 40.6318 49.7933C45.0065 48.8095 48.8025 46.2965 51.4293 42.8455C49.6955 41.8693 47.4753 40.8575 44.806 40.1168ZM36.5 54C48.9265 54 59 43.9265 59 31.5C59 19.0736 48.9265 9 36.5 9C24.0736 9 14 19.0736 14 31.5C14 43.9265 24.0736 54 36.5 54Z",
    fill: "#E7C633"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_340",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_340",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.874645caeb7ec976100ca822e487986c.svg";
export { ForwardRef as ReactComponent };